import React from "react"
import { withTheme } from "emotion-theming"

import Layout from "@layouts/base"

import { Row, Col } from "@components/grid"
import Panel from "@components/panel"
import { Heading } from "@components/type"

import { staff, board } from "@data"

const Volunteer = ({ theme }) => {
  const pageTitle = "Staff & Board"
  return (
    <Layout title={pageTitle}>
      <Panel>
        <Heading colour={theme.colours.primary}>{pageTitle}</Heading>
        <h2>Staff</h2>
        {staff.map(person => (
          <p key={person.name}>
            <strong>{person.name}</strong> | {person.title}
          </p>
        ))}
      </Panel>
      <Panel background={theme.colours.primary}>
        <h2>Board</h2>
        <Row>
          {board.map(person => (
            <Col width={[1, 1 / 2]}>
              <p>
                <strong>{person.name}</strong> | {person.title}
              </p>
            </Col>
          ))}
        </Row>
      </Panel>
    </Layout>
  )
}

export default withTheme(Volunteer)
